<script setup lang="ts">
import ReportSummaryImagesGallery from './ReportSummaryImagesGallery.vue'

import type { ImagesType } from 'Modules/types/generic/image/ImagesType'

const emit = defineEmits<{
  onImagesLoaded: [boolean]
}>()

interface PropTypes {
  images: ImagesType
  inspectionInstance: string
}

const props = defineProps<PropTypes>()
</script>

<template>
  <div id="summary-images">
    <ReportSummaryImagesGallery
      :summary-image-details-obj="props.images"
      :inspection-instance="props.inspectionInstance"
      @on-images-loaded="emit('onImagesLoaded', true)"
    />
  </div>
</template>
